import type { RentalManagerAuthCheckUserInfoWebApiDto } from '@zg-rentals/ts-rental-manager-api-client';
import { RentalManagerUserInfoV2WebApiHandler_get } from '@zg-rentals/ts-rental-manager-api-client';
import { isAuthorized } from '@zg-rentals/auth-comet';
import { defineAuthProvider } from '@zg-rentals/auth-react/legacy';

import { rentalManagerHttpClient } from './app/providers/httpClient';

type User = RentalManagerAuthCheckUserInfoWebApiDto;

export const Auth = defineAuthProvider<object, User>({
  queryOptions: () => ({
    refetchInterval: 3 * 60 * 1000,
    staleTime: 30 * 1000,
    retry: false,
    queryFn: () =>
      RentalManagerUserInfoV2WebApiHandler_get(
        {
          includeCanClaimFreeListings: true,
        },
        rentalManagerHttpClient,
      ),
  }),

  isAuthorized: isAuthorized({
    mapUser: (user) => ({ ...user, isLoggedIn: user.loggedIn }),
  }),
});

export const { useAuth } = Auth;
